export interface ConfigitAceAssignment {
    variableId: string;
    instanceId: string;
    value: string;
    assignedBy?: ConfigitAceAssignedBy;
}

export enum ConfigitAceAssignedBy {
    user = 'User',
    system = 'Rule',
    calculation = 'Calculation',
}

export enum ConfigitAceAssignmentAuthor {
    user = 'byUser',
    system = 'byRule',
    calculation = 'byCalculation',
}

interface ConfigitAceVariableValueBase {
    type: 'IntervalValue' | 'SingletonValue';
    incompatible: boolean;
}

export interface ConfigitAceVariableSingletonValue extends ConfigitAceItem, ConfigitAceVariableValueBase {
    type: 'SingletonValue';
    value: any;
    assigned: ConfigitAceAssignmentAuthor;
}

export interface ConfigitAceVariableIntervalValue extends ConfigitAceVariableValueBase {
    type: 'IntervalValue';
    lower: any;
    upper: any;
    isLowerInfinity: boolean;
    isUpperInfinity: boolean;
}

export type ConfigitAceVariableValue = ConfigitAceVariableSingletonValue | ConfigitAceVariableIntervalValue;

export interface ConfigitAceProperty {
    id: string;
    value: any;
    type: string;
}

export interface ConfigitAceItem {
    id: string;
    name: string;
    properties: ConfigitAceProperty[];
}

export enum ConfigitAceValueType {
    string = 'String',
    number = 'Number',
    date = 'Date',
    boolean = 'Boolean',
}

export interface ConfigitAceVariable extends ConfigitAceItem {
    instanceId: string;
    valueType: ConfigitAceValueType;
    scale: number;
    distinctValueCount: number;
    allowMultipleAssignments: boolean;
    hasAllowedValues: boolean;
    readOnly: boolean;
    isInstanceCollectionVariable: boolean;
    values: ConfigitAceVariableValue[];
}

export interface ConfigitAceSection extends ConfigitAceItem {
    type: string;
    sections: ConfigitAceSection[];
    variables: ConfigitAceVariable[];
}

export interface ConfigitAceConfiguration {
    product: {
        id: string;
        name: string;
    };
    isComplete: boolean;
    sections: ConfigitAceSection[];
    removedAssignments: {
        variableAssignments: {
            type: string;
            variable: ConfigitAceVariable;
            value: ConfigitAceVariableSingletonValue; // assumption: only singleton assignments are in removedAssignments
        }[];
    };
    configuration: {
        metaData: {
            productId: string;
            packagePath: string;
        };
        requestAssignments: ConfigitAceAssignment[];
        configurationAssignments: ConfigitAceAssignment[];
    };
}

export interface ConfigitAceConfigureParams {
    date: string;
    language: string;
    globalArguments: {
        SalesArea: {
            SalesOrganization: string;
            DistributionChannel: string;
            SalesDivision: string;
        };
        Plant: string;
    };
    line: {
        productId: string;
        variableAssignments: ConfigitAceAssignment[];
    };
    settings?: {
        includeConfiguration?: boolean;
        includeStructure?: boolean;
        includeSolutionSpaceInfo?: boolean;
        includeMinimalConflictSet?: boolean;
        includeAnalyzeData?: boolean;
    };
    viewId: string;
}
